export default {
  punches: {
    belowAreThePunchesThatYouRecentlySubmitted: 101420, // Below are the punches that you recently submitted.
    department: 45017, // Department
    departmentPunch: 101412, // Department Punch
    deptDetails: 101409, // Dept. Details:
    in: 100132, // In
    job: 80746, // Job
    jobDetails: 101408, // Job Details:
    jobPunch: 84022, // Job Punch
    lastPunchWasSubmittedAt: 101407, // Last punch was submitted at
    noPunchesToShow: 101528, // No punches to show!
    noPunchesYet: 101421, // No punches yet!
    out: 100133, // Out
    punch: 45531, // Punch
    punchType: 101410, // Punch Type:
    recentPunches: 95017, // Recent Punches
    submitDepartmentPunch: 101414, // Submit Department Punch
    submitJobPunch: 101418, // Submit Job Punch
    successYourPunchWasSubmittedAtPunchTime: 101411, // Success! Your punch was submitted at {PunchTime}
    successYourPunchWasSubmittedAtPunchTimeForPunchType: 101547, // Success! Your punch was submitted at {PunchTime} for {PunchType}!
    thereAreNoValidBadgesInTheSystemForYou: 83011, // There are no valid badges in the system for you.\nPlease contact your supervisor or HR Administrator.
    toSubmitADepartmentPunchMakeSureToSelectAValueForTheDropdownBelow: 101413, // To submit a department punch, make sure to select a value for the dropdown below.
    toSubmitAJobPunchMakeSureToSelectAValueForEachOfTheOptions: 101417, // To submit a job punch, make sure to select a value for each of the options.
    youDoNotHaveAnyRecentPunchesInTheSystem: 95018, // You do not have any recent punches in the system.
    ipAddressIsNotPermitted: 100210, // The IP Address being used to access the system is not permitted to use this feature.
  },
};
